var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYahoo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#6b0094",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.831 6.191h4.247L7.55 13.29l2.505-7.099h4.133L7.963 22.998h-4.16l1.704-4.454L.831 6.191zm18.171 5.672h-4.629L18.482.782h4.613l-4.093 11.081zm-3.417 1.06c1.42 0 2.572 1.294 2.572 2.888 0 1.594-1.152 2.886-2.572 2.886-1.421 0-2.572-1.292-2.572-2.886s1.151-2.888 2.572-2.888z"
  })));
}

export default SvgYahoo;